import * as React from "react";
import { useState } from "react";
import { Button } from "../../../designSystem/button/Button";
import clone from "clone";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Label } from "../../../designSystem/Label";
import { generateSurveyAnswers } from "../../../api/surveyClientApi";
import { Survey, getSurveyStatus } from '../../../amorg-common';
import { Modal } from "../../../designSystem/Modal";
import { TextField } from "../../../designSystem/formField/text/TextField";

type GenerateAnswersModalProps = {
    show:boolean,
    survey:Survey,
    disabled?:boolean,
    onUpdated:() => void,
    onClose:()=>void
};
export const GenerateAnswersModal = (props:GenerateAnswersModalProps): JSX.Element => {
    return (
        <Modal 
                title={"Opret test besvarelser"}
                content={props.show &&
                    <GenerateAnswersPanel 
                         survey={props.survey} 
                         onClickCancel={() => props.onClose()}
                         onCreated={() => {
                             props.onUpdated();
                             props.onClose();
                         }} 
                     />
                }
                showModal={props.show}
                onCancel={() => props.onClose()}/>
    );
};

type GenerateAnswersPanelProps = {
    survey:Survey,
    onCreated:() => void,
    onClickCancel:() => void
}
function GenerateAnswersPanel(props:GenerateAnswersPanelProps): JSX.Element
{
    const [amount, setAmount] = useState('10');
    const [pcts, setPcts] = useState(['20', '20', '20', '20', '20']);

    function parseAmount() {
        return Number.parseInt(amount)
    }

    function isAmountValid(){
        const val = parseAmount();
        if(isNaN(val))
            return false;
        
        return val >= 0 && val <= 1000;
    }

    function parsePct(pct:string) {
        return Number.parseFloat(pct);
    }

    function isPctValid(pct:string){
        const val = parsePct(pct);
        if(isNaN(val))
            return false;
        
        return val >= 0 && val <= 100;
    }

    async function handleClickGenerate()
    {
        if(canSubmit){
            const result = await generateSurveyAnswers(
                props.survey.id,
                parseAmount(),
                {
                    percent1s:parsePct(pcts[0]),
                    percent2s:parsePct(pcts[1]),
                    percent3s:parsePct(pcts[2]),
                    percent4s:parsePct(pcts[3]),
                    percent5s:parsePct(pcts[4])
                }
            );
            if(result.isSuccess)
                props.onCreated();
        }
    }

    const pctsAreValid = isPctValid(pcts[0]) && isPctValid(pcts[1]) && isPctValid(pcts[2]) && isPctValid(pcts[3]) && isPctValid(pcts[4]);
    const pctsAre100 = pctsAreValid && 
        parsePct(pcts[0]) + parsePct(pcts[1]) + parsePct(pcts[2]) + parsePct(pcts[3]) + parsePct(pcts[4]) === 100

    const canSubmit = isAmountValid() && 
        pctsAre100 &&
        getSurveyStatus(props.survey).canSubmitAnswer;

    return (
        <Flex flexDirection="column" gap={16}>
            
            <Label>Procentsatser for fordeling af svarværdier</Label>
            <Flex flexDirection="column" gap={16}>
            
                <TextField
                    value={amount} 
                    onChange={value => setAmount(value)}
                    label={`Antal besvarelser`} 
                    validator={() => { 
                        return isAmountValid()
                            ? {valid:true}
                            : {valid:false, errorMessage:'Ugyldig værdi. Skal være et helt tal mellem 0 og 1000'}}
                    } 
                />
                
                <Flex flexDirection="row" gap={4}>
                    {pcts.map((pct,i) => 
                        <TextField key={i}
                            value={pct} 
                            onChange={value => {
                                const cloned = clone(pcts);
                                cloned[i] = value;
                                setPcts(cloned);
                            }}
                            label={`Værdi: ${i+1}`}
                            trailingIcon='interface_glyph_percent'
                            validator={value => { 
                                return isPctValid(value)
                                    ? {valid:true}
                                    : {valid:false, errorMessage:'Ugyldig % værdi. Skal være mellem 0 og 100'}}
                            } />
                        )}
                </Flex>
            </Flex>

            <Flex flexDirection="row" justifyContent="space-between">
                <Button variant="text"
                    text="Annuller"
                    onClick={props.onClickCancel} />

                <Button variant="filled"
                    text="Opret"
                    disabled={!canSubmit}
                    onClick={handleClickGenerate} />
            </Flex>
        </Flex>
    );
}
